<template>
    <div class="user-profile-tab-activity">
        <user-profile-summary />

        <user-profile-answer-and-question />

        <div class="row">
            <div class="col-md-6">
                <user-profile-tags :items="profileTags" :showPostParcent="false" />
            </div>
            <div class="col-md-6">
                <div class="user-profile-vote-cast-box">
                    <h1 class="fs-17 bg-gray mb-20px p-3 radius-4 d-flex align-center justify-content-between">
                        Votes cast
                        <router-link to="/" class="simple-text-btn">View all votes</router-link>
                    </h1>
                    <ul class="d-grid w-full">
                        <li>
                            <h4>8</h4>
                            <span>upvotes</span>
                        </li>
                        <li>
                            <h4>4</h4>
                            <span>downvotes</span>
                        </li>
                        <li>
                            <h4>4</h4>
                            <span>question votes</span>
                        </li>
                        <li>
                            <h4>8</h4>
                            <span>answer votes</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserProfileAnswerAndQuestion from '../pieces/UserProfile/_UserProfileAnswerAndQuestion.vue'
import UserProfileSummary from '../pieces/UserProfile/_UserProfileSummary.vue'
import UserProfileTags from '../pieces/UserProfile/_UserProfileTags.vue'

export default {
    name: 'UserProfileTabActivity',
    components: { 
        UserProfileSummary,
        UserProfileAnswerAndQuestion,
        UserProfileTags
    },
    data() {
        return {
            profileTags: [
                {
                    id: 1,
                    title: 'glit',
                    score: '58,420',
                    posts: '413',
                    parcent: '21'
                },
                {
                    id: 2,
                    title: 'html',
                    score: '24,422',
                    posts: '4332',
                    parcent: '23'
                },
                {
                    id: 3,
                    title: 'c++',
                    score: '34,422',
                    posts: '432',
                    parcent: '24'
                },
                {
                    id: 4,
                    title: 'c+',
                    score: '3,332',
                    posts: '453',
                    parcent: '19'
                },
                {
                    id: 5,
                    title: 'stl',
                    score: '332',
                    posts: '43',
                    parcent: '5'
                },
                {
                    id: 6,
                    title: 'pointers',
                    score: '3,204',
                    posts: '22',
                    parcent: '5'
                },
                {
                    id: 7,
                    title: 'arrays',
                    score: '10,204',
                    posts: '224',
                    parcent: '22'
                }
            ]
        }
    }
}
</script>